export default __webpack_public_path__ + "static/Custom_apss-8dfcdde226116e3bcd0a8a9faa1c63a1.png";